import React from 'react'
import { Link } from 'react-router-dom'

import './sucursales.scss'

import medanos from '../../assets/img/sucursales/medanos.jpg'
import riocolorado from '../../assets/img/sucursales/riocolorado.jpg'
import algarrobo from '../../assets/img/sucursales/algarrobo.jpg'
import ascasubi from '../../assets/img/sucursales/ascasubi.jpg'
import villalonga from '../../assets/img/sucursales/villalonga.jpg'
import laadela from '../../assets/img/sucursales/laadela.jpg'

const Sucursales = () => {
	document.querySelector('html').scrollTo(0, 0);
	return (
		<>
			<section className="bgTitle bgSucursales py-10">
				<div className="container">
					<div className="row">
						<div className="col-sm-5">
							<h2>NUESTRAS SUCURSALES</h2>
							<h3>SIEMPRE CERCA TUYO</h3>
						</div>
					</div>
				</div>
			</section>

			<section className="grey last postTitle">
				<div className="container my-5">
					<div className="row">

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={medanos} height={375} className="card-img-top" alt="MÉDANOS, Casa central" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>MÉDANOS</strong> | Casa central</h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Anchorena 123 | Villarino, Buenos Aires</p>
								<p className="card-text">
									<a href="tel:02927432089"><i className="fa fa-phone-square" aria-hidden="true"></i> 02927 432089</a><br/>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492914045440&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 0291 15 4045440</a><br/>
									{/* <a href="mailto:medanos@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> medanos@rangocomercial.com.ar</a> */}
									<Link to="/contacto/medanos"><i className="fa fa-envelope" aria-hidden="true"></i> medanos@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/23dztp9s1MknRPQ68" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={riocolorado} height={375} className="card-img-top" alt="Río Colorado" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>RÍO COLORADO</strong></h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Urquiza 571 | Río Colorado, Río Negro</p>
								<p className="card-text">
									<a href="tel:02931432822"><i className="fa fa-phone-square" aria-hidden="true"></i> 02931 432822</a><br/>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916415010&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 0291 15 6415010</a><br/>
									{/* <a href="mailto:riocolorado@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> riocolorado@rangocomercial.com.ar</a> */}
									<Link to="/contacto/riocolorado"><i className="fa fa-envelope" aria-hidden="true"></i> riocolorado@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/rx1RbqTi6oid3yqh8" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={algarrobo} height={375} className="card-img-top" alt="Algarrobo" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>ALGARROBO</strong></h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Av. 25 de Mayo 214 | Algarrobo</p>
								<p className="card-text">
									{/* <a href="tel:02927491289"><i className="fa fa-phone-square" aria-hidden="true"></i> 02927 491289</a><br/> */}
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492915701658&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 0291 5701658</a><br/>
									{/* <a href="mailto:algarrobo@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> algarrobo@rangocomercial.com.ar</a> */}
									<Link to="/contacto/algarrobo"><i className="fa fa-envelope" aria-hidden="true"></i> algarrobo@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/kFkpgG18EA2bWx7r9" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={ascasubi} height={375} className="card-img-top" alt="Hilario Ascasubi" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>HILARIO ASCASUBI</strong></h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Ing. Urgoiti 475 | Hilario Ascasubi</p>
								<p className="card-text">
									<a href="tel:02928491133"><i className="fa fa-phone-square" aria-hidden="true"></i> 02928 491133</a><br/>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916422233&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 0291 15 6422233</a><br/>
									{/* <a href="mailto:ascasubi@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> ascasubi@rangocomercial.com.ar</a> */}
									<Link to="/contacto/ascasubi"><i className="fa fa-envelope" aria-hidden="true"></i> ascasubi@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/y5dvvCGAvVJWJbuH9" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={villalonga} height={375} className="card-img-top" alt="Villalonga" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>VILLALONGA</strong></h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Ntra. Sra. Del Carmen 218 | Patagones</p>
								<p className="card-text">
									<a href="tel:02928492425"><i className="fa fa-phone-square" aria-hidden="true"></i> 02928 492425</a><br/>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916429466&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 0291 15 6429466</a><br/>
									{/* <a href="mailto:villalonga@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> villalonga@rangocomercial.com.ar</a> */}
									<Link to="/contacto/villalonga"><i className="fa fa-envelope" aria-hidden="true"></i> villalonga@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/34fChHTBDJhkPZdJ6" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

						<div className="col-sm-4 my-3 my-sm-4 px-1">
							<div className="card">
								<img src={laadela} height={375} className="card-img-top" alt="Depósito La Adela" />
								<div className="card-body">
								<h5 className="card-title mb-0"><strong>DEPÓSITO LA ADELA</strong></h5>
								<p className="card-text"><i className="fa fa-map-marker" aria-hidden="true"></i> Ruta 22 Km 856 | La Adela, La Pampa</p>
								<p className="card-text">
									 <br/>
									 <br/>
									{/* <a href="mailto:deposito@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> deposito@rangocomercial.com.ar</a> */}
									<Link to="/contacto/deposito"><i className="fa fa-envelope" aria-hidden="true"></i> deposito@rangocomercial.com.ar</Link>
								</p>
								<a target="_blank" href="https://goo.gl/maps/J64njAia5btLsrby9" className="btn btn-primary"><i className="fa fa-map-marker" aria-hidden="true"></i> Ubicar en mapa</a>
								</div>
							</div>
						</div>

					</div>
				</div>
			</section>
		</>
	);
}

export default Sucursales;
